



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { InputInterface } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputEmail extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private data!: { min: any; max: any }
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop({ default: false }) private codeRestrict!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop() customValidity!: string
    @Prop({ default: false }) check_validation!: boolean

    inputValidity = ''

    @Watch('value', { immediate: true, deep:true })
    checkValiditeEmail () {
        // const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        const validRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        if (this.value !== '' && !RegExp(validRegex).test(this.value)) {
            this.inputValidity = 'E-mail invalide'
        } else {
            this.inputValidity =  ''
        }
        this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
    }

    /** 
     * customValidityHandler 
     * Gère la validation personnalisée en définissant la validité personnalisée sur l'élément inputText. 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('customValidity')
    customValidityHandler () {
        const input: any =  this.$refs.inputEmail
        input.checkValidity()
        input.setCustomValidity(this.customValidity)
    }

    /** 
     * validateEMail 
     * Valide l'adresse e-mail en utilisant une expression régulière. 
     * @param {any} e - L'événement contenant la valeur de l'adresse e-mail. 
     */    
    validateEMail (e: any) {
        // const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        const validRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
        if (e.target.value !== '' && !RegExp(validRegex).test(e.target.value)) {
            this.inputValidity = 'E-mail invalide'
        } else {
            this.inputValidity =  ''
        }
        const input: any =  this.$refs.inputEmail
        input.setCustomValidity(this.inputValidity)
        this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
    }

    /** 
     * codeRestrictHandler 
     * Gère les restrictions de saisie pour le code en utilisant des expressions régulières. 
     * @param {any} e - L'événement contenant la saisie de l'utilisateur. 
     */
    codeRestrictHandler (e: any) {
        if (this.codeRestrict) {
            const regPrevent = /^([._a-zA-Z1-9-]+)$/u
            const regReplace = /[^a-zA-Z1-9-]/g
            if (!RegExp(regPrevent).test(e.key)) {
                e.preventDefault()
            }
            setTimeout(() => {
                if (!RegExp(regPrevent).test(e.target.value)) {
                    e.target.value = e.target.value.replace(regReplace, '')
                }
            }, 500)
        }
    }

    /** 
     * inputHandler 
     * Gère la saisie de l'utilisateur en validant l'adresse e-mail et en émettant un événement avec les données de saisie. 
     * @param {any} e - L'événement contenant la saisie de l'utilisateur. 
     */
    inputHandler(e: any) {
        this.validateEMail(e)
        this.$emit('input', { ident: this.ident, value: e.target.value })
    }
}
